import {toast} from "react-toastify"

export const InfoNotification = (message) => toast.info(message)

export const SuccessNotification = (message) => toast.success(message)

export const ErrorNotification = (message) => toast.error(message)

export const WarningNotification = (message) => toast.warning(message)
